import React from "react";

import { type ISchoolClusterPayload } from "../../map-panel-context";

import { ClusterSelectionPanelLayout } from "./cluster-selection/cluster-selection-panel-layout";
import { SchoolClusterSchoolsList } from "./school-cluster-schools-list";
import { SchoolClusterSummary } from "./school-cluster-summary";

interface SchoolClusterPanelContentProps {
  payload: ISchoolClusterPayload | null;
  onSchoolSelect: (schoolId: string) => void;
}

const SchoolClusterPanelContentComponent: React.FC<SchoolClusterPanelContentProps> =
  React.memo(({ payload, onSchoolSelect }) => {
    return (
      <ClusterSelectionPanelLayout>
        <SchoolClusterSummary schoolsCount={payload?.schoolsCount ?? 0} />
        <SchoolClusterSchoolsList
          schools={payload?.schools ?? []}
          onSchoolSelect={onSchoolSelect}
        />
      </ClusterSelectionPanelLayout>
    );
  });

export default SchoolClusterPanelContentComponent;
